import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { CircularProgress } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import { FC, useState } from 'react'
import ReflectionsIcon from '../../assets/icons/Reflections.svg?react'
import MarkdownEditor from '../../pages/InternalPage/RequestMessagesPage/components/MarkdownEditor'

type Props = {
    isPending?: boolean
    reasoning?: string
}

export const Reflections: FC<Props> = ({ isPending, reasoning = '' }) => {
    const [open, setOpen] = useState(false)

    return (
        <Box sx={{ mb: open ? 3 : 1 }}>
            <Button
                sx={{ border: 'none', mb: 1 }}
                color="secondary"
                variant="contained"
                startIcon={isPending ? <CircularProgress size="20px" /> : <ReflectionsIcon />}
                endIcon={
                    <ExpandMoreIcon
                        style={{
                            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                        }}
                    />
                }
                onClick={() => setOpen(!open)}>
                {isPending ? 'Размышляю...' : 'Размышление готово'}
            </Button>
            {open && (
                <Stack direction="row" sx={{ m: 1, opacity: '0.7' }}>
                    <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ height: 'auto', mr: '20px', color: '#E7E8EE' }}
                    />
                    <MarkdownEditor
                        className="reflections-markdown-editor"
                        text={reasoning.replaceAll('---\n', '')}
                    />
                </Stack>
            )}
        </Box>
    )
}
